import { StyledButton } from 'common/components/button/StyledButton';
import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

// Define Props Interface
interface LandingPageProps {
  title: string;
  subtitle: string;
  buttonLabel?: string;
  navDestination?: string;
  onClick?: () => void;
}

const LandingPage: React.FC<LandingPageProps> = ({
  title,
  subtitle,
  buttonLabel,
  navDestination,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    if (navDestination) navigate(navDestination);
  };

  return (
    <Container>
      <WelcomeTitle>{title}</WelcomeTitle>
      <Subtitle>{subtitle}</Subtitle>
      {buttonLabel && buttonLabel.length > 0 && (navDestination || onClick) && (
        <StyledButton color="green" label={buttonLabel} width="200px" onClick={handleClick} />
      )}
    </Container>
  );
};

export default LandingPage;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30vh;
  padding: 20px;
  color: black;
  text-align: center;
`;

const WelcomeTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 15px;
  text-transform: uppercase;
`;

const Subtitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 1.2rem;
  margin-bottom: 30px;
`;
